import React, { useEffect, useState } from 'react'
import ConfigTable from '../configTable/configTable';
import TestAttemptsListTable from './testAttempts/testAttemptsListing';
import TestControl from '../projectList/testControl';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store/appStore';
import { Typography } from '@mui/material';
// import TestAnalysis from './testAnalysis/TestAnalysis';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


interface TestTabOptionsProps {
  testTab: string;
}

const TestTabOptions: React.FC<TestTabOptionsProps> = ({ testTab }) => {
  const [alignment, setAlignment] = useState(testTab);
  const projectData = useSelector((state: RootState) => state.projects.project);
  useEffect(() => {
    if (testTab) {
      setAlignment(testTab);
    }
  }, [testTab]);

  const isTestEnable = projectData?.is_test_enabled;

  return (
    <>
      <div
        style={{
          borderBottom: '1px solid',
          borderColor: '#E8EAEF',
          margin: '0 2px 2px 2px',
          padding: '0px, 24px, 0px, 24px'
        }}
      >
        {alignment === "questions" && (
          <ConfigTable />
        )}
        {alignment === "control" && (
          <TestControl />
        )}
        {alignment === "attempts" && (
          <TestAttemptsListTable />
        )}
        {/* {alignment === "analysis" && (
        <TestAnalysis />
      )} */}
      </div>
    </>
  )
}

export default TestTabOptions